import { useLocation } from "@gatsbyjs/reach-router";
import React from "react";

// import styles from './LoginDialogError.module.css';

export default function LoginDialogError() {
  const location = useLocation();
  return (
    <>
      <p>Could not find login handler</p>
      <pre>
        <code>{JSON.stringify(location, null, 2)}</code>
      </pre>
    </>
  );
}
